import { Controller, UseFormReturn } from "react-hook-form";
import { roleDepartment } from "../../../../lib/atecos/dto";
import { keycloak } from "../../../../lib/keycloak";
import { useAppSelector } from "../../../../lib/redux/hooks";
import { groupBy } from "../../../../lib/utils";
import Input from "../../../../ui/molecules/input";
import { SelectCustom } from "../../../../ui/molecules/select";
import { NewParticularity } from "../../../particularities/newParticularity";
import { ProjectDTO } from "../../../projects/dto";
import { UserRole } from "../../../users/dto";
import { SelectUser } from "../../../users/select/userSelect";
import { CounterDTO } from "../../contacts/dto";
import { UpdateTargetListFormValues } from "../validation";
import { AtecosSegment } from "./atecos";
import { ComparisonFieldEmployees } from "./employees";
import { ComparisonFieldRevenue } from "./revenue";

interface Props {
  form: UseFormReturn<UpdateTargetListFormValues>;
  peopleCounters: CounterDTO
  companiesCounters: CounterDTO
  project: ProjectDTO
}

export function Form(props: Props) {
  const { peopleCounters, companiesCounters, form, project } = props

  const disabled = (peopleCounters?.inList?.total || 0) + (peopleCounters?.targetListBin?.total || 0) > 0 || (companiesCounters?.inList?.total || 0) + (companiesCounters?.targetListBin?.total || 0) > 0
  const departments = form.watch("departments");

  return (
    <div className="flex flex-col gap-6 p-4">
      <div className="flex gap-4">
        <Controller
          name="name"
          control={form.control}
          render={({ field }) => (
            <Input
              {...field}
              value={field.value || ""}
              placeholder="Nome lista target"
              label="Nome del Target"
              disabled={disabled || keycloak.hasRealmRole("customer") || keycloak.hasRealmRole("collaborator")}
              supportingText={form.formState.errors.name?.message as string | undefined}
              error={!!form.formState.errors.name}
            />
          )}
        />
        <Controller
          name="departments"
          control={form.control}
          render={({ field }) => (
            <SelectCustom
              isMulti
              disabled={disabled || keycloak.hasRealmRole("customer") || keycloak.hasRealmRole("collaborator")}
              placeholder={"Indifferente"}
              options={groupBy(roleDepartment, "department").map((department) => ({
                label: department.key,
                value: department.key,
              }))}
              label="Reparti"
              defaultValue={field.value ?? []}
              onChange={(e) => field.onChange(e)}
            />
          )}
        />
        <Controller
          name="roles"
          control={form.control}
          render={({ field }) => (
            <SelectCustom
              isMulti
              placeholder={"Indifferente"}
              disabled={disabled || keycloak.hasRealmRole("customer") || keycloak.hasRealmRole("collaborator")}
              options={groupBy(
                roleDepartment.filter((row) => departments.includes(row.department)),
                "role"
              ).map((department) => ({
                label: department.key,
                value: department.key,
              }))}
              label="Ruoli"
              defaultValue={field.value ?? []}
              onChange={(e) => field.onChange(e)}
            />
          )}
        />
      </div>
      <div className=" gap-4 grid grid-cols-3 w-full">
        <div className="col-span-2">
          <AtecosSegment
            sectors={form.watch("sectors")}
            categories={form.watch("categories")}
            setSectors={e => form.setValue("sectors", e)}
            setCategories={e => form.setValue("categories", e)}
          />
        </div>
        <div className="cols-span-1">
          <Controller
            name="commercialIds"
            control={form.control}
            render={({ field }) => (
              <>
                <SelectCustom
                  key="select-commercials-edit-target-filters"
                  label="Assegna ai commerciali"
                  isMulti
                  isClearable
                  defaultValue={field.value ?? []}
                  onChange={(e) => field.onChange(e)}
                  placeholder={"Seleziona i commerciali"}
                  error={!!form.formState.errors.commercialIds}
                  errorLabel={form.formState.errors.commercialIds?.message as string | undefined}
                  options={project?.commercials?.map(c => ({ label: c.name + " " + c.surname, value: c.id })) || []}
                />
                {/* <SelectUser
                  isMulti={true}
                  filterUsers={user => user.filter(u => project?.commercials?.map(c => c.id)?.includes(u.id))}
                  id="select-commercials-edit-target-filters"
                  role={UserRole.commercial}
                  value={field.value ?? []}
                  onChange={(e) => field.onChange(e)}
                  label="Assegna ai commerciali"
                  placeholder={"Seleziona i commerciali"}
                  isClearable
                  error={!!form.formState.errors.commercialIds}
                  errorLabel={form.formState.errors.commercialIds?.message as string | undefined}
                /> */}
              </>
            )}
          />
        </div>
      </div>
      <div className="flex gap-4 w-full">
        <div className="w-full">
          <ComparisonFieldRevenue
            disabled={disabled}
            value={form.watch("revenue")}
            onChange={e => form.setValue("revenue", e)}
            label="Fatturato"
            placeholder="Valore fatturato"
            error={!!form.formState.errors.revenue}
            errorMessage={form.formState.errors.revenue?.message as string | undefined}
          />
        </div>
      </div>
      <div className="flex gap-4 w-full">
        <div className="w-full">
          <Controller
            name="employeesNumber"
            control={form.control}
            render={({ field }) => (
              <ComparisonFieldEmployees
                value={field.value}
                disabled={disabled}
                onChange={field.onChange}
                label="Numero di dipendenti"
                placeholder="Valore numero di dipendenti"
                error={!!form.formState.errors.employeesNumber}
              />
            )}
          />
        </div>
      </div>
      <NewParticularity />
    </div>
  );
}
